import { render, staticRenderFns } from "./table-answer-input.vue?vue&type=template&id=28487b57&scoped=true"
import script from "./table-answer-input.vue?vue&type=script&lang=js"
export * from "./table-answer-input.vue?vue&type=script&lang=js"
import style0 from "./table-answer-input.vue?vue&type=style&index=0&id=28487b57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28487b57",
  null
  
)

export default component.exports